import { Avatar, Card, Col, Layout, Row, Image } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import MerchantSidebar from "./sidebar";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const MerchantLayout = ({
  children,
  merchantId,
}: {
  children: ReactElement;
  merchantId: string;
}): ReactElement => {
  const { merchantInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="shop-banner">
                        <Image
                          src={getImgUrl(merchantInfo?.image)}
                          alt={merchantInfo?.name}
                          className="rounded"
                        />
                      </div>

                      <div className="shop-image-content">
                        <div className="shop-logo">
                          <Avatar
                            size={105}
                            src={getImgUrl(merchantInfo?.image)}
                          />
                        </div>
                        <div className="body">
                          <h4>
                            {merchantInfo?.name?.toUpperCase()}
                            {/* <Badge>
                              {merchantInfo?.deleted === true ? (
                                <FontAwesomeIcon
                                  icon={faCheckCircle}
                                  className="text-success ml-2"
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="text-danger ml-2"
                                />
                              )}
                            </Badge> */}
                          </h4>
                          <div className="mb-4">
                            <span className="radius-btn active-btn">
                              {merchantInfo?.phone?.split("+88")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <MerchantSidebar merchantId={merchantId} />
              </Card>
            </Col>
            <Col span={18}>
              <Card className="product-information-show-tab-wrapper" size="small">
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

MerchantLayout.propType = {
  children: PropTypes.element,
};

export default MerchantLayout;
